import { Menu, Portal, Icon, Stack } from '@chakra-ui/react'
import { FaChevronRight } from 'react-icons/fa'

export default ({ closeOnSelect, trigger, children }) => {
  return (
    <Menu.Root closeOnSelect={closeOnSelect}>
      <Menu.Trigger asChild>{trigger}</Menu.Trigger>
      <Portal>
        <Menu.Positioner>
          <Menu.Content>
            {children}
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  )
}

const SubMenu = ({ trigger, children }) => {
  return (
    <Menu.Root>
      <Menu.TriggerItem>
        <Stack direction='row' align='center' justify='space-between' width='100%'>
          {trigger} <Icon><FaChevronRight /></Icon>
        </Stack>
      </Menu.TriggerItem>
      <Portal>
        <Menu.Positioner>
          <Menu.Content maxW='300px'>
            {children}
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  )
}

const MenuItem = Menu.Item
const MenuGroup = Menu.ItemGroup
const MenuSeparator = Menu.Separator

export { MenuItem, MenuGroup, SubMenu, MenuSeparator }
